import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MenuChangeEvent } from '../api/menuchangeevent';
import { PrimeIcons } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  constructor() {}

  private menuSource = new Subject<MenuChangeEvent>();
  private resetSource = new Subject();

  menuSource$ = this.menuSource.asObservable();
  resetSource$ = this.resetSource.asObservable();

  menuModel = [
    {
      label: 'Home',
      expanded: true,
      items: [
        {
          label: 'Dashboard',
          icon: `pi pi-fw ${PrimeIcons.HOME}`,
          routerLink: ['/'],
        },
      ],
    },
    {
      label: 'Customer Management',
      expanded: false,
      items: [
        {
          label: 'Account Search',
          icon: `pi pi-fw ${PrimeIcons.SEARCH}`,
          routerLink: ['/accounts/search'],
        },
        {
          label: 'RTBF',
          icon: `pi pi-fw ${PrimeIcons.TIMES}`,
          routerLink: ['/rtbf'],
        },
        {
          label: 'Orderstream XR',
          icon: `pi pi-fw ${PrimeIcons.CODE}`,
          routerLink: ['/orderstream-xr'],
        },
        {
          label: 'Orderstream CTL',
          icon: `pi pi-fw ${PrimeIcons.LINK}`,
          routerLink: ['/orderstream-ctl'],
        },
      ],
    },
    {
      label: 'Database',
      expanded: false,
      items: [
        {
          label: 'Reports',
          icon: `pi pi-fw ${PrimeIcons.TABLE}`,
          routerLink: ['/reports'],
        },
      ],
    },
    {
      label: 'File Search',
      expanded: false,
      items: [
        {
          label: 'Search',
          icon: `pi pi-fw ${PrimeIcons.SEARCH}`,
          routerLink: ['/fs/search'],
        },
        {
          label: 'Browser',
          icon: `pi pi-fw ${PrimeIcons.FILE}`,
          routerLink: ['/fs/browser'],
        },
      ],
    },
    {
      label: 'Pulse',
      expanded: false,
      items: [
        {
          label: 'Home',
          icon: `pi-fw ${PrimeIcons.HOME}`,
          routerLink: ['/pulse'],
        },
        {
          label: 'Wizard',
          icon: `pi-fw ${PrimeIcons.SPARKLES}`,
          routerLink: ['/pulse/wizard'],
        },
        {
          label: 'Customers',
          icon: `pi-fw ${PrimeIcons.TH_LARGE}`,
          routerLink: ['/pulse/customers'],
        },
        {
          label: 'Accounts (BETA)',
          icon: `pi-fw ${PrimeIcons.BUILDING}`,
          routerLink: ['/pulse/accounts'],
        },
        {
          label: 'AS2 Connections (BETA)',
          icon: `pi-fw ${PrimeIcons.USERS}`,
          routerLink: ['/pulse/connections/as2'],
        },
        {
          label: 'AS2 Connections',
          icon: `pi-fw ${PrimeIcons.USERS}`,
          routerLink: ['/pulse/partners'],
        },
        {
          label: 'Correlate',
          icon: `pi-fw ${PrimeIcons.ARROW_RIGHT_ARROW_LEFT}`,
          routerLink: ['/pulse/correlate'],
        },
        {
          label: 'Logs',
          icon: `pi-fw ${PrimeIcons.FILE}`,
          routerLink: ['/pulse/messages'],
        },
        {
          label: 'Errors',
          icon: `pi-fw ${PrimeIcons.TIMES_CIRCLE}`,
          routerLink: ['/pulse/errors'],
        },
      ],
    },
    {
      label: 'Customer Billing',
      expanded: false,
      items: [
        {
          label: 'Dashboard',
          icon: `pi pi-fw ${PrimeIcons.CHART_BAR}`,
          routerLink: ['/cbdi'],
        },
        {
          label: 'Companies Search',
          icon: 'pi pi-fw pi-search',
          routerLink: ['/cbdi/companies-search'],
        },
      ],
    },
    {
      label: 'Troubleshooting & Diagnosis',
      expanded: false,
      items: [
        {
          label: 'Lookup Order',
          icon: 'pi pi-fw pi-file',
          routerLink: ['/optiks/start'],
        },
        {
          label: 'Shipping Label',
          icon: 'pi pi-fw pi-tag',
          routerLink: ['/troubleshooting/shipping-label'],
        },
        {
          label: 'Active Delivery Management',
          icon: 'pi pi-fw pi-truck',
          routerLink: ['/troubleshooting/adm'],
        },
      ],
    },
    {
      label: 'Items tooling',
      expanded: false,
      items: [
        {
          label: 'Tier 1 Normalization',
          icon: `pi pi-fw ${PrimeIcons.WRENCH}`,
          routerLink: ['/items/tier-1'],
        },
      ],
    },
    {
      label: 'Notification Service',
      expanded: false,
      items: [
        {
          label: 'Notification Config',
          icon: `pi pi-fw ${PrimeIcons.COG}`,
          routerLink: ['/notification-service/config'],
        },
        {
          label: 'Customer Delivery Metadata',
          icon: `pi pi-fw ${PrimeIcons.USERS}`,
          routerLink: ['/notification-service/customer-delivery-metadata'],
        },
        {
          label: 'Templates',
          icon: `pi pi-fw ${PrimeIcons.FILE}`,
          routerLink: ['/notification-service/templates'],
        },
        {
          label: 'Delivery Logs',
          icon: `pi pi-fw ${PrimeIcons.LIST}`,
          routerLink: ['/notification-service/delivery-logs'],
        },
        {
          label: 'Health Dashboard',
          icon: `pi pi-fw ${PrimeIcons.HEART}`,
          routerLink: ['/notification-service/delivery-health'],
        },
      ],
    }
  ];

  onMenuStateChange(event: MenuChangeEvent) {
    this.menuSource.next(event);
  }
}
